<template>
    <div>
        <div class="d-none d-md-flex flex-row-reverse">
            <v-chip
                :class="chipCSSClass"
                color="primary"
                text-color="white"
                link
                @click="shareLink"
                :loading="gettingLink"
                :disabled="gettingLink"
            >
                <v-avatar left>
                    <v-icon dark>$vuetify.icons.share-alt</v-icon>
                </v-avatar>
                <span>Share</span>
            </v-chip>
        </div>

        <v-snackbar
            v-model="snackbar.isVisible"
            top
            :timeout="snackbar.timeout"
            :color="snackbar.color"
        >
            <span v-html="snackbar.text"></span>
            <v-btn
                flat
                @click="snackbar.isVisible = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<style lang="scss">
    .clickable {
        cursor: pointer;
        .v-chip__content {
            cursor: pointer;
        }
    }

    /*
    Animation

    For the animation: http://animista.net/
    To calculate the delay between iterations: https://waitanimate.wstone.io/#!/
    */
    .wobble-hor-bottom {
        animation: wobble-hor-bottom_6869 30.8s ease-in-out infinite;
        transform-origin: 50% 50%;
    }

    @keyframes wobble-hor-bottom_6869 {
        0% {
            transform: translateX(0%);
            transform-origin: 50% 50%; }
        0.38961% {
            transform: translateX(-10px) rotate(-6deg); }
        0.77922% {
            transform: translateX(8px) rotate(6deg); }
        1.16883% {
            transform: translateX(-8px) rotate(-3.6deg); }
        1.55844% {
            transform: translateX(5px) rotate(2.4deg); }
        1.94805% {
            transform: translateX(0px) rotate(0deg); }
        100% {
            transform: translateX(0px) rotate(0deg); }
    }
</style>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  import GetCookie from '../utils/getcookie'
  import _get from 'lodash/get'
  import copy from '../mixins/copy'

  export default {
    props: ['animation'],
    mixins: [copy],

    data: function () {
      return {
        gettingLink: false,
        dialog: false,
        url: null,
        snackbar: {
          isVisible: false,
          color: 'success',
          timeout: 0
        },
        snackbarText: '',
        showTooltip: false,
        on: false
      }
    },

    computed: {
      chipCSSClass: function () {
        return {
          'clickable': true,
          'wobble-hor-bottom': this.animation === 'wobble-hor-bottom'
        }
      },
      ...mapState([
        // map this.customband to store.state.customband
        'customband'
      ])
    },

    methods: {
      copyToClipboard (text) {
        this.copyTextToClipboard(text)
        this.showTooltip = true
        setTimeout(() => (this.showTooltip = false), 3000)
      },

      shareLink () {
        let getCookie = new GetCookie()
        let axiosConfig = {
          headers: {
            'X-CSRFToken': getCookie.csrf()
          }
        }

        let postData = {
          category: 15,
          sub_category: 47,
          manifest: this.customband.getDataForSelectedRow(),
          variant: this.customband.getVariantId(),
          layout: this.customband.layout.id
        }

        this.gettingLink = true
        axios.post('/builder/design-link/', postData, axiosConfig).then((resp) => {
          this.gettingLink = false

          // Send event to Google Analytics
          if (typeof gtag !== 'undefined') {
            gtag('event', 'share builder image', {
              'event_category': 'bandbuilder',
              'event_label': 'Share Builder Image',
            })
          }

          let status = _get(resp, 'data.status')
          if (status === 'success') {
            this.url = resp.data.url
            this.copyTextToClipboard(this.url)
            resp.data.message = `Share this link that was also copied to your clipboard<br>${this.url}`
            this.processSuccess(resp.data)
          } else {
            this.processError(resp.data)
          }
        }).catch((error) => {
          this.gettingLink = false
          this.processError(error)
        })
      },

      processSuccess (success) {
        // console.log('success', success)
        let msg = _get(success, 'message', 'Success!')

        // Show success Snackbar
        this.snackbar.isVisible = true
        this.snackbar.color = 'success'
        this.snackbar.text = msg
        this.snackbar.timeout = 0
      },
      processError (error) {
        let message = ''
        if (error.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          // console.log('error.response', error.response)
          message = `${error.response.statusText}: Please contact customer service`
          // console.log('message', message)
        } else if (error.request) {
          // console.log('error.request', error.request)
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          message = 'Oops! That did not work. Please try again.'
        } else {
          // Something happened in setting up the request that triggered an Error
          message = error.message
        }

        // Show error
        this.snackbar.isVisible = true
        this.snackbar.color = 'error'
        this.snackbar.text = message
        this.snackbar.timeout = 0
      }
    }

  }
</script>
